import React from 'react';
import BackendActionRenderer from './BackendActionRenderer';
import ModalRenderer from './ModalRenderer';
import FormRenderer from './FormRenderer';
import WorkflowRenderer from './WorkflowRenderer';
import ReportRenderer from './ReportRenderer';
import ChatRenderer from './ChatRenderer';
import CustomComponentRenderer from './CustomComponentRenderer';

const TemplateRenderer = (props) => {
  const { definition, agentId, token, onClose, onNavigate, onSubmit, loading, workflowContext } = props;
  console.log('🎨 TemplateRenderer props DETAILED:', {
    definition: !!definition,
    agentId,
    token: !!token,
    loading: loading,
    template_type: definition?.template_type,
    onClose: typeof onClose,
    onNavigate: typeof onNavigate,
    onSubmit: typeof onSubmit,
    workflowContext,
    allProps: Object.keys(props || {})
  });
  
  if (!definition) {
    return (
      <div className="p-6 text-center">
        <div className="text-red-500 mb-2">⚠</div>
        <p className="text-gray-600 dark:text-gray-400">
          No template definition provided
        </p>
      </div>
    );
  }

  const { template_type } = definition;

  // Route to appropriate renderer based on template type
  switch (template_type) {
    case 'backend_action':
      return (
        <BackendActionRenderer
          definition={definition}
          agentId={agentId}
          token={token}
          onClose={onClose}
        />
      );

    case 'modal':
      return (
        <ModalRenderer
          definition={definition}
          agentId={agentId}
          token={token}
          onClose={onClose}
          onNavigate={onNavigate}
        />
      );

    case 'form':
      return (
        <FormRenderer
          definition={definition}
          agentId={agentId}
          token={token}
          onClose={onClose}
          onNavigate={onNavigate}
          onSubmit={onSubmit}
          loading={loading}
          workflowContext={workflowContext}
        />
      );

    case 'workflow':
      return (
        <WorkflowRenderer
          definition={definition}
          agentId={agentId}
          token={token}
          onClose={onClose}
          onNavigate={onNavigate}
        />
      );

    case 'report':
      return (
        <ReportRenderer
          definition={definition}
          agentId={agentId}
          token={token}
          onClose={onClose}
          onNavigate={onNavigate}
        />
      );

    case 'chat':
      return (
        <ChatRenderer
          definition={definition}
          agentId={agentId}
          token={token}
          onClose={onClose}
          onNavigate={onNavigate}
        />
      );

    case 'custom':
      return (
        <CustomComponentRenderer
          definition={definition}
          agentId={agentId}
          token={token}
          onClose={onClose}
          onSubmit={onSubmit}
          workflowContext={workflowContext}
        />
      );

    default:
      return (
        <div className="p-6 text-center">
          <div className="text-yellow-500 mb-2">⚠</div>
          <p className="text-gray-600 dark:text-gray-400">
            Unknown template type: {template_type}
          </p>
        </div>
      );
  }
};

export default TemplateRenderer;